import {
  ControlRules,
  Group,
  IInvitation,
} from '@jupiterone/jupiter-web-toolkit';

export type AccountModalPage =
  | 'access'
  | 'apiKeys'
  | 'profile'
  | 'invitations'
  | 'clients'
  | 'accountManagement'
  | 'notifications';

export enum SettingsPage {
  'access',
  'apiKeys',
  'profile',
  'invitations',
  'clients',
  'accountManagement',
  'notifications',
}
export interface QueryPermissions {
  [permissionType: string]: string[];
}

export interface GroupQueryPermissions {
  filtersByGroupId: {
    [groupId: string]: QueryPermissions;
  };
}

export interface CacheState {
  loading: boolean;
  refetchRequired: boolean;
  error: any;
}

export interface PendingSentInvitationsState extends CacheState {
  pendingSentInvitations?: IInvitation[];
}

export enum Policy {
  // AdministratorAccess and FullReadAccess
  // need to match what is here in the account-service:
  // https://bitbucket.org/lifeomic/account-service/src/872fd4b0ab08a468934dd6356645437bd41b3409/src/services/PolicyService.js#lines-196
  // the others can be whatever
  AdministratorAccess = 'Administrator Access',
  FullReadAccess = 'Full Read Access',

  ApiKeyUserAccess = 'ApiKeyUser Access',
  AppAccess = 'App Access',
  SharedAccess = 'Shared Access',
}

export enum PolicyRule {
  AccountAdmin = 'accountAdmin',
  APIKey = 'apiKeyUser',
  ComplianceAccess = 'accessCompliance',
  ComplianceAdmin = 'adminCompliance',
  RulesAccess = 'accessRules',
  RulesAdmin = 'adminRules',
  AssetsAccess = 'accessAssets',
  AssetsAdmin = 'adminAssets',
  EndpointComplianceAccess = 'accessEndpointCompliance',
  EndpointComplianceAdmin = 'adminEndpointCompliance',
  PoliciesAccess = 'accessPolicies',
  PoliciesAdmin = 'adminPolicies',
  FullAdmin = 'accessAdmin',
  FullRead = 'fullReadAccess',
  GalaxyAccess = 'accessGalaxy',
  GalaxyAdmin = 'adminGalaxy',
  InsightsAccess = 'accessInsights',
  InsightsAdmin = 'adminInsights',
  IntegrationsAccess = 'accessIntegrations',
  IntegrationsAdmin = 'adminIntegrations',
  LandingAccess = 'accessLanding',
  LandingAdmin = 'adminLanding',
  MySecurityAccess = 'accessMySecurity',
  MySecurityAdmin = 'adminMySecurity',
  ReadGraph = 'readGraph',
  WriteGraph = 'writeGraph',
  ReadQuestions = 'readQuestions',
  WriteQuestions = 'writeQuestions',
}

export type RelevantPolicyMap = {
  [policy in Policy]?: ControlRules;
};

export interface RelevantPoliciesState extends CacheState {
  policyMap: RelevantPolicyMap;
}

export interface FetchLinks {
  next?: string;
  self?: string;
}
export interface GroupsState extends CacheState {
  groups?: Group[];
  fetchLinks?: FetchLinks;
  shouldFetchAll?: boolean;
}

export type CacheReducer<T = CacheState, TT = T> = (state: T) => TT;
export type CacheStateReducer = <T extends CacheState>(state: T) => T;

export type UsageDataMetrics =
  | 'entityCount'
  | 'relationshipCount'
  | 'billableEntityCount'
  | 'j1RuleCount';

export type UsageDataPoint = {
  accountId: string;
  timeRangeType: 'day' | 'month' | 'year';
  startTimestamp: number;
  endTimestamp: number;
  metrics: {
    [key in UsageDataMetrics]: number;
  };
};
